import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const items = ['Window Cleaning', 'Gutter Cleaning', 'Pressure Washing', 'Free Estimates', 'Licensed & Insured', 'Photo Proof', 'Flat-Rate Pricing', 'Locally Owned'];
export function Marquee() {
  const loop = [...items, ...items];
  return <div className="w-full overflow-hidden border-y-4 border-brand-navy bg-brand-blue py-4" data-id="element-119" data-mp="2dmdy736hlo9w">
      <motion.ul className="flex w-max items-center gap-10" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 28,
      ease: 'linear',
      repeat: Infinity
    }} aria-hidden="true" data-id="element-120" data-mp="3b7t7z4h0pmx1">
        {loop.map((item, index) => <li key={`${item}-${index}`} className="flex items-center gap-10 whitespace-nowrap font-display text-lg tracking-tight text-white sm:text-xl" data-id="element-121" data-mp="2x937rfywj74g" data-mpi={index}>
            {item.toUpperCase()}
            <Sparkles className="h-5 w-5 text-brand-navy" data-id="element-122" data-mp="1lsbuahs8m7o9" />
          </li>)}
      </motion.ul>
      <p className="sr-only" data-id="element-123" data-mp="2ticra5th65sn">
        Window cleaning, gutter cleaning and pressure washing with free
        estimates, flat-rate pricing and photo proof.
      </p>
    </div>;
}